export const ENTITY_PROCEDURE_SECTION_ID = 'consultas-e-horarios';
export const ENTITY_PROCEDURE_ASIDE_SECTION_ID = 'consultas-e-horarios-lateral';
